import especiesRacas from "@/utils/especiesRacas";

export default {
  comportamentos: ["Dócil", "Obediente", "Agressivo", "Inquieto", "Medroso"],
  especies: Object.keys(especiesRacas).map((especie) => especie),
  pelagens: ["Curta", "Média", "Longa"],
  portes: ["Grande", "Gigante", "Médio", "Miniatura", "Pequeno"],
  getRacas: (especie) => especiesRacas[especie] || [],
};
